import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../config/config";
import axiosInstance from "../../../interceptors";

const candidateKey = (interviewId, userId) => `${interviewId}_${userId}`;

const getCandidateCompetencyScores = createAsyncThunk(
  "getCandidateCompetencyScores",
  async ({ interviewId, userId }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/candidate-competency-score/get`,
        { interviewId, userId }
      );
      if (data.success) return { key: candidateKey(interviewId, userId), items: data.data || [] };
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const computeCandidateCompetencyScores = createAsyncThunk(
  "computeCandidateCompetencyScores",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(
        `${baseUrl}/job-posting/api/candidate-competency-score/compute`,
        payload
      );
      if (data.success) {
        return {
          key: candidateKey(payload.interviewId, payload.userId),
          items: data.data || [],
        };
      }
      return rejectWithValue(data.message);
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export {
  getCandidateCompetencyScores,
  computeCandidateCompetencyScores,
  candidateKey,
};
